module.exports = __webpack_public_path__ + "mainassets/img/tilearrow.0482f89e.svg";